import Vue from 'vue'
import moment from 'moment'
import firebase from '@/firebase/firebase'

const db = firebase.firestore()

export default {
  namespaced: true,
  state: {
    availableTables: [],
    lastTableFetch: new Date(),
  },
  actions: {
    async fetchTables({ commit, state, rootGetters }, force = false) {
      const tablesRef = db.collection(`/company/${rootGetters.getCompanyID}/tables/`).orderBy('number')
      const canFetchAgain = moment(state.lastTableFetch).add('30', 'm').toDate() < moment(new Date()).toDate()
      if(!state.availableTables.length || force || canFetchAgain) {
        const tablesSnap = await tablesRef.get()
        tablesSnap.docs.forEach(x => {
          const table = x.data()
          commit('addTable', {
            id: x.id,
            number: table.number,
            shortUrl: table.shortUrl,
            createdAt: new firebase.firestore.Timestamp(table.createdAt.seconds, table.createdAt.nanoseconds).toDate(),
          })
        })

        commit('setLastTableFetch', new Date())
      }
    },

    async fetchTableClicks({ commit, state }, { force = false, tableId }) {
      const localTableIndex = state.availableTables.findIndex(x => x.id === tableId)
      let canFetchAgain = true
      if (localTableIndex >= 0) {
        if (state.availableTables[localTableIndex].hasOwnProperty('lastClickFetch')) {
          canFetchAgain = moment(state.availableTables[localTableIndex].lastClickFetch).add('10', 'm').toDate() < moment(new Date()).toDate()
        }

        const tableRef = db.collection(`/shortUrls/`).doc(tableId)
        if (force || canFetchAgain) {
          const tableSnap = await tableRef.get()
          if(tableSnap.exists) {
            const totalClicks = (tableSnap.data()).counters.clicks
            commit('setTableClicks', { tableIndex: localTableIndex, clicks: totalClicks })
            commit('setLastClickFetch', { lastClickFetch: new Date(), tableIndex: localTableIndex })
          }
        }
      }
    },

    async removeTable({ commit, state, rootGetters }, id) {
      await db.collection(`/company/${rootGetters.getCompanyID}/tables/`).doc(id).delete()
      const index = state.availableTables.findIndex(table => table.id === id)
      if(index >= 0) commit('deleteTable', index)
    },
  },
  mutations: {
    addTable(state, table) {
      state.availableTables.push(table)
    },
    setTableClicks(state, { tableIndex, clicks }) {
      Vue.set(state.availableTables[tableIndex], 'clicks', clicks)
    },
    setLastClickFetch(state, { lastClickFetch, tableIndex }) {
      Vue.set(state.availableTables[tableIndex], 'lastClickFetch', lastClickFetch)
    },

    setLastTableFetch(state, lastFetch) {
      state.lastTableFetch = lastFetch
    },
    deleteTable(state, tableIndex) {
      Vue.delete(state.availableTables, tableIndex)
    }
  }
}